import React, { useState, useEffect } from 'react';

import PropTypes from 'prop-types';
import { Field } from 'formik';

import ErrorIcon from '../../../assets/images/icon_error_messages.gif';
import request from '../../utils/request';
import { sortedObjects } from '../../utils/utils';
import Label from './common/label';

const MultiProvince = ({ labels, errors, touched }) => {
  const [provinceList, setProvinceList] = useState([]);

  useEffect(() => {
    request.get('/provinces').then(({ data: { provinces } }) => {
      setProvinceList(provinces);
    });
  }, []);

  return (
    <>
      <Label labelName={labels.SELECT_PROVINCE} />
      <div
        style={{ position: 'relative', width: '100%' }}
        className={`frg-select-container color-light input-container ${
          errors.multiProvinces && touched.multiProvinces ? 'error' : ''
        }`}
      >
        <div role="group" aria-labelledby="checkbox-group">
          {provinceList &&
            provinceList.length > 0 &&
            sortedObjects(provinceList, 'name').map(province => {
              return (
                <div>
                  <Field
                    type="checkbox"
                    name="multiProvinces"
                    value={province.id.toString()}
                  />
                  <span style={{ marginLeft: '0.5rem' }}>{province.name}</span>
                </div>
              );
            })}
        </div>
        <>
          <div className="error_messages">
            <span className="frg-body-font-14px">{errors.multiProvinces}</span>
          </div>
          <div id="multiProvinces_error_icon" className="error_messages_icon">
            <img src={ErrorIcon} alt="error_icon" />
          </div>
        </>
      </div>
    </>
  );
};

MultiProvince.propTypes = {
  labels: PropTypes.isRequired,
  errors: PropTypes.isRequired,
  touched: PropTypes.func.isRequired
};

export default MultiProvince;
